export const BASE_ROUTE = '/personal-investing/tools/pamwebsite/';

export const FOOTER_LINKS = {
  siteMapUrl:
    'https://individual.troweprice.com/public/Retail/hUtility/SiteMap?scn=footer',
  privacyPolicyUrl:
    'https://individual.troweprice.com/public/Retail/hUtility/Policies-&-Security/Privacy?scn=footer',
  termsOfUseUrl:
    'https://individual.troweprice.com/public/Retail/hUtility/TermsOfUse?scn=footer',
  legalInformationUrl:
    'https://individual.troweprice.com/public/Retail/hUtility/Policies-&-Security/Legal-Information?scn=footer',
  prospectusUrl:
    'http://individual.troweprice.com/public/Retail/Mutual-Funds/hProspectuses&Reports/Prospectuses-&-Reports?src=ql_footer',
  mutualFundProspectus:
    'https://www.troweprice.com/personal-investing/funds/mutual-funds/prospectuses-reports.html',
  ETFProspectus:
    'https://www.troweprice.com/personal-investing/funds/etfs/prospectuses-reports.html'
};

export const ROUTE_PARAMS = {
  ACCOUNT_ID: 'accountId'
};

export const ROUTE = {
  PATH: `${BASE_ROUTE}`,
  ACCOUNT: {
    PATH: `/:${ROUTE_PARAMS.ACCOUNT_ID}`
  }
};

export const ASSET_NAME = {
  RESERVES: 'Reserves',
  FIXED_INCOME: 'Fixed Income',
  EQUITIES: 'Equities'
};

export const TABLE_HEADING_ANALYSIS = {
  PAST_PERIODS: 'Past Periods',
  CONTRIBUTIONS_WITHDRAWALS: 'Contributions & Withdrawals',
  CAPITAL_CHANGE: 'Capital Change',
  CAPITAL_INVESTMENT: 'Capital Investment',
  MARKET_VALUE_EOP: 'Market Value at End of Period',
  EARNED_INCOME: 'Earned Income',
  REINVESTED_INCOME: 'Reinvested Income',
  YTD_RETURN_PERCENT: 'Year-to-Date %Return',
  INCEPTION_RETURN_PERCENT: 'Since Inception %Return'
};

export const TABLE_HEADING_HOLDINGS = {
  NAME: 'Security Description',
  QUANTITY: 'Quantity',
  COST: 'Cost',
  ANNUAL_INCOME: 'Estimated Annual Income',
  MARKET_YIELD_PERCENT: 'Estimated Yield at Market',
  MARKET_PER_UNIT: 'Market Per Unit',
  MARKET_VALUE: 'Market Value',
  UNREALIZED_GAIN_LOSS: 'Unrealized Gain/Loss',
  PERCENT_OF_PORTFOLIO: 'Percent of Portfolio',
  PERCENT_OF_ASSET_CLASS: 'Percent of  Asset Class',
  INVESTMENT_GUIDELINES: 'Investment Guidelines'
};

export const TABLE_HEADING_PERFORMANCE = {
  NAME: ' ',
  ONE_MONTH: 'One Month',
  THREE_MONTH: 'Three Month',
  YEAR_TO_DATE: 'Year-to-Date',
  ONE_YEAR: 'One Year',
  TWO_YEARS: 'Two Year',
  THREE_YEARS: 'Three Year',
  FIVE_YEARS: 'Five Year',
  TEN_YEARS: 'Ten Year',
  SINCE_INCEPTION: 'Since Inception'
};

export const TABLE_HEADING_ANALYSIS_LIST = [
  TABLE_HEADING_ANALYSIS.PAST_PERIODS,
  TABLE_HEADING_ANALYSIS.CAPITAL_CHANGE,
  TABLE_HEADING_ANALYSIS.CAPITAL_INVESTMENT,
  TABLE_HEADING_ANALYSIS.MARKET_VALUE_EOP,
  TABLE_HEADING_ANALYSIS.EARNED_INCOME,
  TABLE_HEADING_ANALYSIS.REINVESTED_INCOME,
  TABLE_HEADING_ANALYSIS.YTD_RETURN_PERCENT,
  TABLE_HEADING_ANALYSIS.INCEPTION_RETURN_PERCENT
];

export const TABLE_HEADING_HOLDINGS_LIST = [
  TABLE_HEADING_HOLDINGS.NAME,
  TABLE_HEADING_HOLDINGS.QUANTITY,
  TABLE_HEADING_HOLDINGS.COST,
  TABLE_HEADING_HOLDINGS.ANNUAL_INCOME,
  TABLE_HEADING_HOLDINGS.MARKET_YIELD_PERCENT,
  TABLE_HEADING_HOLDINGS.MARKET_PER_UNIT,
  TABLE_HEADING_HOLDINGS.MARKET_VALUE,
  TABLE_HEADING_HOLDINGS.UNREALIZED_GAIN_LOSS,
  TABLE_HEADING_HOLDINGS.PERCENT_OF_PORTFOLIO,
  TABLE_HEADING_HOLDINGS.PERCENT_OF_ASSET_CLASS
];

export const TABLE_HEADING_PERFORMANCE_LIST = [
  TABLE_HEADING_PERFORMANCE.NAME,
  TABLE_HEADING_PERFORMANCE.YEAR_TO_DATE,
  TABLE_HEADING_PERFORMANCE.ONE_YEAR,
  TABLE_HEADING_PERFORMANCE.THREE_YEARS,
  TABLE_HEADING_PERFORMANCE.FIVE_YEARS,
  TABLE_HEADING_PERFORMANCE.TEN_YEARS,
  TABLE_HEADING_PERFORMANCE.SINCE_INCEPTION
];

export const INVALID_ACCOUNT_IDENTIFIER = 'INVALID_ACCOUNT_IDENTIFIER';
export const HISTORY_PUSH = 'PUSH';

export const DONUT_CHART_DEFAULT_OPTIONS: DonutChartOptions = {
  size: 165,
  strokeWidth: 30,
  offsetRatio: 0.25,
  classNames: []
};

export const NAVIGATION_KEYS = {
  ACCOUNT_ACCESS_MODAL: 'accountAccessModal',
  ACCOUNT_LIST_MODAL: 'accountListModal',
  HELP_MODAL: 'helpModal',
  LEGAL_AGREEMENT_MODAL: 'legalAgreementModal',
  NAV_LINKS: 'navigationLinks'
};

export const MAX_HALF_WIDTH_ALLOCATION_BAR_LENGTH: number = 264;
export const MAX_FULL_WIDTH_ALLOCATION_BAR_LENGTH: number = 900;
export const MAX_PHONE_VIEW_ALLOCATION_BAR_LENGTH: number = 192;
